import React from 'react';
import * as Styled from './PageHeader.styles';

const PageHeader = ({ children }) => (
  <Styled.PageHeader>{children}</Styled.PageHeader>
);

export default PageHeader;
